import { categories } from "@/mocks/categories";

export default function CategorySection() {
  const handleClick = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              Shop by <span className="text-accent-500">Category</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mt-2">
              Browse our complete spreadsheet-organized product collections
            </p>
          </div>
          <span className="hidden sm:inline-flex items-center gap-1.5 bg-secondary-100 text-secondary-900 text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap">
            14 Collections
          </span>
        </div>

        <div className="flex overflow-x-auto gap-4 md:gap-5 pb-4 -mx-4 px-4 md:px-6" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => handleClick(cat.url)}
              className="flex-shrink-0 w-[180px] md:w-[200px] group cursor-pointer"
            >
              <div className="aspect-square rounded-xl overflow-hidden mb-3 bg-background-50">
                <img
                  src={cat.imageUrl}
                  alt={`OOPBuy Spreadsheet ${cat.name} category`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <p className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </p>
              <p className="text-xs text-foreground-500 mt-0.5">
                {cat.description}
              </p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}